const gradesOrder = [
  {
    order: 0,
    value: 'p'
  },
  {
    order: 1,
    value: 'k'
  },
  {
    order: 3,
    value: '1'
  },
  {
    order: 4,
    value: '2'
  },
  {
    order: 5,
    value: '3'
  },
  {
    order: 6,
    value: '4'
  },
  {
    order: 7,
    value: '5'
  },
  {
    order: 8,
    value: '6'
  },
  {
    order: 9,
    value: '7'
  },
  {
    order: 10,
    value: '8'
  }
]

const getGradeOrder = grade => {
  const foundGrade = gradesOrder.find(g => g.value === grade.toString().toLowerCase())

  return foundGrade ? foundGrade.order : undefined
}

export const studentsLength = state => state.students.length

export const findStudent = (state, id) => state.students.find(s => s.id === id)

export const sortedStudents = state => state.students.sort((a, b) => getGradeOrder(a.grade) > getGradeOrder(b.grade))

export const isLoaded = state => state.isLoaded

export default {
  findStudent,
  isLoaded,
  studentsLength,
  sortedStudents
}
